/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum StatusTransition {
  Reject = 0,
  Hold = 1,
}

export enum WorkOrderSortFields {
  CreatedDate = 0,
  ObjectAddress1 = 1,
  Foreman = 2,
  WorkOrderNumber = 3,
  CreatedBy = 4,
}

export enum SelfInspectionState {
  Missing = 0,
  Started = 1,
  Partial = 2,
  Completed = 3,
  NotApplicable = 4,
}

export enum WorkOrderState {
  Unknown = 0,
  Draft = 500,
  Registered = 1000,
  InProgress = 2000,
  WaitingForVerification = 2500,
  WorkDone = 3000,
  ReadyForInvoicing = 4000,
  Invoiced = 5000,
  Finished = 6000,
  Deleted = 7000,
  Cancelled = 8000,
}

export enum RiskAssessment {
  NotAssessed = 0,
  Assessed = 1,
  NotApplicable = 2,
}

export enum SubtaskStatus {
  NotStarted = 0,
  InProgress = 1,
  Done = 2,
}

export enum SortDirection {
  Ascending = 0,
  Descending = 1,
}

export enum ProjectSortFields {
  ProjectNumber = 0,
  StartDate = 1,
}

export enum ProjectListModelErpStatus {
  Unknown = 0,
  Registered = 1000,
  InProgress = 2000,
  WorkDone = 3000,
  ReadyForInvoicing = 4000,
  Finished = 5000,
  Deleted = 6000,
  Cancelled = 7000,
}

export enum SourceSystem {
  Hubb = 0,
  Erp = 1,
  Planner = 2,
  Toolbox = 3,
}

export enum FileType2 {
  Document = 0,
  Image = 1,
}

export enum CreditCheckStatus {
  NotChecked = 0,
  Approved = 1,
  NotApproved = 2,
  Grade = 4,
  NotNeeded = 5,
}

export enum InspectionStage {
  Pre = 0,
  Post = 1,
}

export enum QuestionType {
  YesNo = 0,
}

export enum InspectionState {
  Missing = 0,
  Started = 1,
  Partial = 2,
  Completed = 3,
  NotApplicable = 4,
}

export enum WorkSize {
  Small = 0,
  Large = 1,
  AsbestoAdministration = 2,
}

export enum SensorStatus {
  Any = 0,
  Active = 1,
  Disconnected = 2,
}

export enum CorroventaAlarmKind {
  ServiceReminder = 0,
  Value = 1,
  Activity = 2,
  Network = 3,
  LowBattery = 4,
  Other = 5,
}

export enum FileType {
  Document = 0,
  Image = 1,
}

export enum DraftSortDirection {
  Ascending = 0,
  Descending = 1,
}

export enum DraftSortFields {
  CreatedDate = 0,
  ObjectAddress1 = 1,
  NextStepDueAt = 2,
}

export enum DraftListActionAlerts {
  None = 0,
  Information = 1,
  Warning = 2,
  Error = 3,
}

export enum DraftState {
  Unknown = 0,
  New = 1000,
  InProgress = 2000,
  OfferSent = 2500,
  Finished = 3000,
  FinishedManualProcess = 3500,
  CancelledOther = 4000,
  CancelledNoContact = 4100,
  CancelledPrice = 4200,
  CancelledNoAvailability = 4300,
  CancelledServiceNotAvailable = 4400,
  CancelledCustomerCancellation = 4500,
}

export enum CreditCheckConsumerStatus {
  Active = 0,
  Protected = 1,
  Locked = 2,
  Deceased = 3,
  RemovedFromRegister = 4,
  Emigrated = 5,
}

export enum CreditCheckCompanyStatus {
  Positive = 0,
  Negative = 1,
  Neutral = 2,
}

export interface UserMeResponse {
  isAuthenticated: boolean;
  roles: string[];
  profile?: UserProfile | null;
  companies: CompanyInformation[];
}

export interface UserProfile {
  /** @format int32 */
  userId: number;
  name: string;
  email: string;
  mainCompany: CompanyInformation;
  signature: string;
}

export interface CompanyInformation {
  id: string;
  name: string;
}

export interface ApplicationVersion {
  version: string;
}

export interface CreateCustomerResponse {
  customerNumber: string;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  extensions: Record<string, any>;
  [key: string]: any;
}

export interface CreateCustomerModel {
  name: string;
  address: CustomerAddressModel;
  organizationNumber: string;
  email?: string | null;
  customerGroupId: string;
}

export interface CustomerAddressModel {
  address1?: string | null;
  address2?: string | null;
  zip: string;
  city: string;
}

export interface CreditCheckCompanyModel {
  status: CreditCheckCompanyStatus;
  name: string;
  address: CustomerAddressModel;
  organizationNumber: string;
  companyType: string;
  isApproved: boolean;
}

export interface CreditCheckConsumerModel {
  status: CreditCheckConsumerStatus;
  name: string;
  address: CustomerAddressModel;
  personalIdentityNumber: string;
  isApproved: boolean;
}

export interface CreditCheckResultModel {
  /** @format int32 */
  status: number;
  statusText: string;
  errors: string[];
}

export interface CreditCheckRequestModel {
  organizationNumber: string;
}

export interface CustomerSearchResultModel {
  customerNumber: string;
  name: string;
  address: CustomerAddressModel;
  organizationNumber: string;
  email: string;
  defaultPricelistId: string;
  group: CustomerGroup;
  customerNote?: string | null;
}

export interface CustomerGroup {
  id: string;
  name: string;
}

export interface CustomerWithCreditCheckModel {
  customer: CustomerSearchResultModel;
  creditCheck: CreditCheckResultModel;
}

export interface InsuranceCompanySearchModel {
  insuranceCompanyNumber: string;
  name: string;
  address: CustomerAddressModel;
  organizationNumber: string;
  email: string;
}

export interface CreateDraftResponseModel {
  /** @format guid */
  id: string;
}

export interface CreateDraftWorkOrderResult {
  /** @format guid */
  id: string;
  failedFiles: string[];
}

export interface CreateDraftModel {
  subject?: string | null;
  officeId?: string | null;
  description?: string | null;
  /** @format date-time */
  submittedDate?: string | null;
  files: DraftAttachmentModel[];
  zendeskReference?: string | null;
  mepsReference?: string | null;
  product?: DraftProductModel | null;
  contactPerson?: DraftContactModel | null;
  customerContact?: DraftContactModel | null;
  customerInformation?: CustomerInformation | null;
  object?: DraftObjectModel | null;
  order?: DraftOrderModel | null;
}

export interface DraftAttachmentModel {
  /** @format int64 */
  id: number;
  fileName: string;
  contentUrl: string;
  mappedContentUrl: string;
  contentType: string;
  size: string;
  /** @format int64 */
  realSize: number;
  /** @format int32 */
  width?: number | null;
  /** @format int32 */
  height?: number | null;
}

export interface DraftProductModel {
  /** @format decimal */
  price?: number | null;
  articleNumber?: string | null;
}

export interface DraftContactModel {
  /** @format guid */
  id?: string | null;
  name?: string | null;
  phone?: string | null;
  email?: string | null;
  type: ContactType;
}

export interface ContactType {
  id: string;
  name: string;
}

export interface CustomerInformation {
  name?: string | null;
  reference?: string | null;
  orgPersNumber?: string | null;
  address1?: string | null;
  address2?: string | null;
  zip?: string | null;
  city?: string | null;
  customerNumber?: string | null;
  email?: string | null;
}

export interface DraftObjectModel {
  title?: string | null;
  propertyEntryCode?: string | null;
  propertyEntryInformation?: string | null;
  address: Address;
}

export interface Address {
  address1?: string | null;
  address2?: string | null;
  zip?: string | null;
  city?: string | null;
  apartmentNumber?: string | null;
}

export interface DraftOrderModel {
  workType?: string | null;
  department?: string | null;
  assignedTo?: string | null;
  workDescription?: string | null;
  shortDescription?: string | null;
  status?: string | null;
  draftState: DraftState;
  workCauseId?: string | null;
}

export interface DraftModel {
  draftId: string;
  companyId: string;
  workOrderId?: string | null;
  office?: OfficeModel | null;
  subject?: string | null;
  ezNumber: string;
  description?: string | null;
  /** @format date-time */
  submittedDate?: string | null;
  files: any[];
  zendeskReference?: string | null;
  mepsReference?: string | null;
  product?: DraftProductModel | null;
  contacts: DraftContactModel[];
  customerInformation: CustomerInformation;
  object: DraftObjectModel;
  order: DraftOrderModel;
  logs: LogModel[];
  state: WorkOrderState;
  nextStep?: NextStepModel | null;
  cancellationComment?: string | null;
}

export interface CancelDraftModel {
  reason?: DraftState | null;
  reasonComment?: string | null;
}

export enum NextStepType {
  ContactNew = 1000,
  ContactRetry = 1100,
  SendOffer = 2000,
  WeReturn = 2100,
  SiteVisit = 2200,
  WaitOffer = 3000,
  WaitCustomer = 3100,
}

export enum NextStepStatus {
  New = 1000,
  InProgress = 2000,
  Waiting = 3000,
  Closed = 4000,
}

export interface NextStepModel {
  type: NextStepType;
  status: NextStepStatus;
  /** @format date-time */
  dueAt: string;
  comment?: string | null;
  setBy: UserModel;
  /** @format date-time */
  setAt: string;
}

export enum ContactOutcome {
  Reached = 1,
  NotReached = 2,
}

export interface SetNextStepModel {
  type: NextStepType;
  /** @format date-time */
  dueAt?: string | null;
  comment?: string | null;
  contactOutcome?: ContactOutcome | null;
}

export interface OfficeModel {
  id: string;
  name: string;
  email: string;
  companyName: string;
}

export interface LogModel {
  /** @format date-time */
  createdDate: string;
  logType: string;
  title: string;
  description: string;
  signature: string;
}

export interface ChangeOfficeRequest {
  id: string;
  comment?: string | null;
}

export interface ChangeStateRequest {
  state: DraftState;
  comment?: string | null;
  workOrderNumber?: string | null;
}

export interface ChangeAssignmentRequest {
  signature?: string | null;
  email?: string | null;
  comment?: string | null;
}

export interface CreateLogModel {
  logType: string;
  title: string;
  description: string;
  mentions: UserMentionModel[];
}

export interface UserMentionModel {
  firstName: string;
  lastName: string;
  signature: string;
  email?: string | null;
}

export interface DraftListResultModel {
  entries: DraftWorkOrderListModel[];
  facets: Facet[];
  /** @format int32 */
  total: number;
}

export interface DraftWorkOrderListModel {
  draftId: string;
  companyId: string;
  /** Set once the ärende has been gjort till AO (promotion keeps the draft's id). */
  workOrderId?: string | null;
  office?: OfficeModel | null;
  subject?: string | null;
  ezNumber: string;
  description?: string | null;
  /** @format date-time */
  submittedDate?: string | null;
  /** @format date-time */
  createdDate?: string | null;
  zendeskReference?: string | null;
  mepsReference?: string | null;
  order?: DraftOrderModel | null;
  object?: DraftObjectModel | null;
  nextStep?: NextStepModel | null;
  cancellationComment?: string | null;
  lastActivity?: DraftLastActivityModel | null;
  /** Only the legacy draft list still returns this; the beta list dropped it with the Draftlogs join. */
  lastAction?: DraftListLastAction | null;
}

export interface DraftLastActivityModel {
  kind?: string | null;
  name?: string | null;
  text: string;
  /** @format date-time */
  date: string;
  user?: HistoryUserModel | null;
  data?: Record<string, string | null>;
}

export interface DraftListLastAction {
  /** @format int32 */
  daysAgo: number;
  signature: string;
  draftListAlerts: DraftListActionAlerts;
  logDetails?: string | null;
}

export interface FileModel {
  /** @format guid */
  id: string;
  type: FileType;
  title: string;
  mimeType?: string | null;
  url: string;
  thumbnailUrl?: string | null;
  createdDate: string;
  size?: string | null;
  attachedToInvoice: boolean;
  /** @format int32 */
  mediaTypeId?: number | null;
  /** @format byte */
  isHidden: number;
}

export interface OptionsModel {
  offices: OfficeModel[];
  states: DraftStateModel[];
}

export interface DraftStateModel {
  /** @format int32 */
  id: number;
  name: string;
  description: string;
  isSelectable: boolean;
}

export interface ProjectChangeModel {
  companyId: string;
  projectNumber: string;
  userSignature: string;
}

export interface WorkOrderChangeModel {
  companyId: string;
  workOrderNumber: string;
  userSignature?: string | null;
}

export interface CorroventaCheckModel {
  activeProject?: CorroventaProject | null;
  newProject?: CorroventaCurrent | null;
}

export interface CorroventaProject {
  /** @format guid */
  id: string;
  /** @format guid */
  workOrderId: string;
  companyId: string;
  /** @format date-time */
  createdDate: string;
  /** @format date-time */
  disconnectDate?: string | null;
  /** @format int32 */
  projectId: number;
  gatewayIds: string[];
  name?: string | null;
  /** @format date-time */
  connectedDate?: string | null;
}

export interface CorroventaCurrent {
  createdDate?: string | null;
  status?: string | null;
  /** @format int32 */
  projectId: number;
  gatewayIds: string[];
  nodeIds: string[];
  name?: string | null;
}

export interface AddCorroventaProjectResultModel {
  /** @format guid */
  id: string;
}

export interface AddCorroventaProjectModel {
  /** @format int32 */
  projectId: number;
  gateways: CorroventaGateway[];
  name?: string | null;
}

export interface CorroventaGateway {
  gatewayId: string;
  name?: string | null;
}

export interface CorroventaLatestModel {
  /** @format guid */
  id: string;
  title: string;
  /** @format int32 */
  projectId: number;
  devices: CorroventaDevice[];
  /** @format date-time */
  disconnectedDate?: string | null;
}

export interface CorroventaDevice {
  serial: string;
  /** @format int32 */
  nodeId: number;
  sensors: CorroventaSensor[];
}

export interface CorroventaSensor {
  alias: string;
  data: CorroventaData[];
}

export interface CorroventaData {
  type: string;
  /** @format decimal */
  lastValidValue: number;
  unit: string;
  /** @format date-time */
  timestamp?: string | null;
}

export interface CorroventaHistoryModel {
  /** @format guid */
  id: string;
  title: string;
  /** @format int32 */
  projectId: number;
  nodes: CorroventaHistoryNode[];
  gatewayIds: string[];
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  disconnectedDate?: string | null;
}

export interface CorroventaHistoryNode {
  /** @format int32 */
  id: number;
  name: string;
  dataTypes: CorroventaHistoryDataType[];
}

export interface CorroventaHistoryDataType {
  name: string;
  unit: string;
  data: CorroventaHistoryData[];
}

export interface CorroventaHistoryData {
  /** @format date-time */
  time: string;
  /** @format decimal */
  value?: number | null;
}

export interface SuperVisionModbusData {
  /** @format int32 */
  nodeId: number;
  serial: string;
  machineType: string;
  /** @format int32 */
  projectId: number;
  /** @format int32 */
  networkRole: number;
  waterSeparator?: SuperVisionWaterSeparator | null;
  /** @format int32 */
  currentAirVolume?: number | null;
  settings?: SuperVisionSettings[] | null;
}

export interface SuperVisionWaterSeparator {
  /** @format int32 */
  status: number;
  /** @format int32 */
  counter: number;
  lastActive: string;
}

export interface SuperVisionSettings {
  name: string;
  currentValueRaw?: any | null;
  allowedValues?: number[] | null;
  writable: boolean;
  valueLimits?: ValueLimits | null;
  currentValue: string;
}

export interface ValueLimits {
  /** @format decimal */
  min: number;
  /** @format decimal */
  max: number;
  /** @format decimal */
  step: number;
}

export interface SuperVisionPush {
  /** @format int32 */
  id: number;
  /** @format int32 */
  nodeId: number;
  status: SuperVisionPushStatus;
  settingsPushed?: any | null;
  createdAtString?: string | null;
  /** @format date-time */
  createdAt?: string | null;
}

export interface SuperVisionPushStatus {
  /** @format int32 */
  value: number;
  description?: string | null;
}

export interface CorroventaAlarmModel {
  /** @format int32 */
  alarmId: number;
  /** @format guid */
  corroventaProjectId: string;
  /** @format int32 */
  nodeId: number;
  kind: CorroventaAlarmKind;
  text?: string | null;
  /** @format date-time */
  triggerTime: string;
}

export interface SensorListModel {
  /** @format guid */
  id: string;
  name?: string | null;
  /** @format date-time */
  createdDate: string;
  /** @format date-time */
  disconnectDate?: string | null;
  hardwareId: string;
  /** @format guid */
  workOrderId: string;
}

export interface AddSensorResultModel {
  /** @format guid */
  id: string;
}

export interface AddSensorModel {
  hardwareId: string;
  name?: string | null;
  /** @format int32 */
  targetValue?: number | null;
}

export interface SensorModel {
  /** @format guid */
  id: string;
  name?: string | null;
  hardwareId: string;
  /** @format date-time */
  createdDate: string;
  /** @format date-time */
  disconnectDate?: string | null;
  /** @format date-time */
  lastContactDate?: string | null;
  /** @format int32 */
  batteryLevel?: number | null;
  /** @format int32 */
  signalQuality: number;
  measurementPoints: MeasurementPointModel[];
  /** @format int32 */
  targetValue?: number | null;
}

export interface MeasurementPointModel {
  type: string;
  unit: string;
  /** @format double */
  latestValue?: number | null;
}

export interface MeasurementPointHistoryModel {
  type: string;
  unit: string;
  values: MeasurementPointValueModel[];
}

export interface MeasurementPointValueModel {
  /** @format date-time */
  date: string;
  /** @format double */
  value: number;
}

export interface RiskAssessmentResultModel {
  /** @format date-time */
  createdDate: string;
  /** @format int32 */
  version: number;
  comment?: string | null;
  lastEditedBy: RiskUserModel;
  training: SelectedItemsModel;
  gear: SelectedItemsModel;
  risks: SelectedRisksModel;
}

export interface RiskUserModel {
  firstName: string;
  lastName: string;
  signature: string;
  email?: string | null;
}

export interface SelectedItemsModel {
  list: AssessmentItemModel[];
  extra?: string | null;
}

export interface AssessmentItemModel {
  title: string;
}

export interface SelectedRisksModel {
  list: AssessmentRiskModel[];
  extra?: string | null;
}

export interface AssessmentRiskModel {
  title: string;
  answers: RiskTopicAnswerModel[];
}

export interface RiskTopicAnswerModel {
  question: string;
  information?: string | null;
  questionType: string;
  answer?: string | null;
  answers: string[];
  comment?: string | null;
}

export interface RiskAssessmentEditModel {
  comment?: string | null;
  gear: EditSelectedItemsModel;
  training: EditSelectedItemsModel;
  risk: EditSelectedItemsModel;
  answers: Record<string, RiskAnswerModel[]>;
}

export interface EditSelectedItemsModel {
  extra?: string | null;
  selected: RiskItemModel[];
}

export interface RiskItemModel {
  /** @format guid */
  uuid: string;
  title: string;
  constName: string;
  /** @format int32 */
  sortOrder: number;
}

export interface RiskAnswerModel {
  question: string;
  answer?: string | null;
  answerArray: string[];
  comment?: string | null;
  info?: string | null;
  questionType: string;
  /** @format int32 */
  sortOrder: number;
  /** @format guid */
  questionId: string;
  /** @format guid */
  possibleRiskId: string;
}

export interface WorkOrderRiskAssessmentModel {
  riskAssessments: RiskAssessmentListModel[];
  /**
   * @deprecated
   * @format guid
   */
  riskAssessmentId?: string | null;
  signedByUsers: RiskUserModel[];
}

export interface RiskAssessmentListModel {
  /** @format guid */
  riskAssessmentId: string;
  /** @format int32 */
  version: number;
  /** @format date-time */
  createdDate: string;
  createdBy: RiskUserModel;
}

export interface SelectedRiskItemResultModel {
  list: RiskItemModel[];
}

export interface RiskQuestionResultModel {
  list: RiskQuestionModel[];
  links: RiskLinkModel[];
}

export interface RiskQuestionModel {
  /** @format guid */
  questionId: string;
  /** @format guid */
  possibleRiskId: string;
  question: string;
  info?: string | null;
  commentHint?: string | null;
  /** @format int32 */
  sortOrder: number;
  questionType: string;
  answers: string[];
}

export interface RiskLinkModel {
  title: string;
  url: string;
  /** @format guid */
  uuid: string;
}

export interface RiskAddResultModel {
  success: boolean;
  message: string;
}

export interface RiskAssessmentModel {
  /** @format guid */
  uuid: string;
  comment?: string | null;
  answers: RiskAnswerModel[];
  risks: RiskItemModel[];
  protectiveGear: RiskItemModel[];
  training: RiskItemModel[];
  extraRisk?: string | null;
  extraProtectiveGear?: string | null;
  extraTraining?: string | null;
}

export interface RiskTemplateListModel {
  list: RiskTemplateModel[];
}

export interface RiskTemplateModel {
  /** @format guid */
  uuid: string;
  title: string;
  constName: string;
  /** @format int32 */
  sortOrder: number;
  isActive: boolean;
  list: RiskQuestionModel[];
  links: RiskLinkModel[];
  bulletPoint: RiskBulletsModel[];
}

export interface RiskBulletsModel {
  groupId: string;
  /** @format guid */
  possibleRiskId: string;
  rows: RiskQuestionModel[];
}

export interface RiskTemplateResultModel {
  success: boolean;
  message: string;
}

export interface RiskTemplateActiveModel {
  /** @format guid */
  uuid: string;
  isActive: boolean;
}

export interface InspectionStatusModel {
  workType: SelfInspectionWorkType;
  availableWorkSizes: WorkSize[];
  isChangeable: boolean;
  preInspection: InspectionStageStatusModel;
  postInspection: InspectionStageStatusModel;
}

export interface SelfInspectionWorkType {
  id: string;
  name: string;
}

export interface InspectionStageStatusModel {
  state: InspectionState;
}

export interface UpdateInspectionModel {
  workSize: WorkSize;
}

export interface CreateInspectionModel {
  workTypeId: string;
  workSize: WorkSize;
}

export interface InspectionModel {
  /** @format date-time */
  lastAnswerDate?: string | null;
  lastAnsweredBy?: InspectionUserModel | null;
  workTypeId?: string | null;
  workSize?: WorkSize | null;
  /** @format int32 */
  version: number;
  questions: QuestionModel[];
  answers: AnswerModel[];
  state: InspectionState;
}

export interface InspectionUserModel {
  firstName: string;
  lastName: string;
  signature: string;
  email?: string | null;
}

export interface QuestionModel {
  id: string;
  title: string;
  description: string;
  type: QuestionType;
}

export interface AnswerModel {
  questionId: string;
  answer: AnswerDataModel;
}

export interface AnswerDataModel {
  value: string;
  comment?: string | null;
}

export interface WasteTypeItem {
  /** @format int32 */
  id?: number | null;
  type: string;
  name: string;
  comment: string;
  /** @format decimal */
  amount: number;
}

export interface CreateTransportResponseModel {
  /** @format guid */
  id: string;
}

export interface WasteTransport {
  /** @format guid */
  id?: string | null;
  producer: ProducerInfo;
  transporter: TransporterInfo;
  originInfo: OriginInfo;
  /** @format date-time */
  transportDate: string;
  receiver: CompanyInfo;
  wasteTypes: WasteTypeItem[];
  hasSigned: boolean;
  signer?: SignerInfo | null;
  /** @format date-time */
  createdDate?: string | null;
  hasSentToNaturvardsverket: boolean;
  state: string;
}

export type ProducerInfo = CompanyInfo & {
  phone?: string;
};

export interface CompanyInfo {
  companyName: string;
  organizationNumber: string;
  address: string;
  postalCode: string;
  city: string;
}

export interface TransporterInfo {
  isOcab: boolean;
  companyName?: string | null;
  organizationNumber?: string | null;
  address?: string | null;
  postalCode?: string | null;
  city?: string | null;
}

export interface OriginInfo {
  address?: string | null;
  postalCode?: string | null;
  city?: string | null;
}

export interface SignerInfo {
  name: string;
  /** @format date-time */
  date?: string | null;
}

export interface WasteStationsResponseModel {
  wasteStations: WasteStation[];
}

export interface WasteStation {
  companyName: string;
  organizationNumber: string;
  address: string;
  postalCode: string;
  city: string;
  officeId: string;
  companyId: string;
}

export interface AgendaListModel {
  /** @format date-time */
  date: string;
  workOrder: AgendaWorkOrderModel;
  appointment?: AgendaAppointmentModel | null;
  timeReport: AgendaTimeReportModel;
  expenseReport: AgendaExpenseReportModel;
}

export interface AgendaWorkOrderModel {
  /** @format guid */
  workOrderId: string;
  workOrderNumber: string;
  address?: string | null;
  city?: string | null;
}

export interface AgendaAppointmentModel {
  /** @format guid */
  appointmentId: string;
  /** @format duration */
  startTime?: string | null;
  /** @format duration */
  endTime?: string | null;
  assignedUsers: UserModel[];
}

export interface UserModel {
  firstName: string;
  lastName: string;
  signature: string;
  email?: string | null;
  costCenter?: string | null;
}

export interface AgendaTimeReportModel {
  /** @format decimal */
  totalHours: number;
}

export interface AgendaExpenseReportModel {
  /** @format int32 */
  count: number;
}

export interface AgendaScheduleModel {
  /** @format date-time */
  date: string;
  /** @format decimal */
  expectedHours: number;
}

export interface AddCommentModel {
  text: string;
  mentionedUsers: UserModel[];
}

export interface CommentModel {
  /** @format guid */
  id: string;
  author: UserModel;
  /** @format date-time */
  createdDate: string;
  text: string;
  mentionedUsers: UserModel[];
  /** @format date-time */
  deletedDate?: string | null;
}

export interface ContactModel {
  /** @format guid */
  id?: string | null;
  name?: string | null;
  phone?: string | null;
  phone2?: string | null;
  email?: string | null;
  role?: ContactRoleModel | null;
}

export interface ContactRoleModel {
  id: string;
  name: string;
}

export interface UpdateContactModel {
  name: string;
  phone?: string | null;
  phone2?: string | null;
  email?: string | null;
  role: ContactRoleModel;
}

export interface ContactSearchModel {
  name?: string | null;
  phone?: string | null;
  phone2?: string | null;
  email?: string | null;
  role?: ContactRoleModel | null;
}

export interface CreateWorkOrderResponseModel {
  /** @format guid */
  id: string;
  workOrderNumber: string;
}

export interface CreateJourWorkOrderModel {
  companyId: string;
  creatorSignature: string;
  object: ObjectModel;
  customer: CustomerModel;
  contacts: JourContactModel[];
  finance: FinanceModel;
  order: JourOrderModel;
}

export interface ObjectModel {
  title?: string | null;
  address: AddressModel;
  apartmentNumber?: string | null;
  propertyEntryCode?: string | null;
  propertyEntryInformation?: string | null;
  /** @format decimal */
  distanceToOffice?: number | null;
}

export interface AddressModel {
  address1?: string | null;
  address2?: string | null;
  zip?: string | null;
  city?: string | null;
}

export interface CustomerModel {
  name?: string | null;
  address: AddressModel;
  email?: string | null;
  customerNumber?: string | null;
  organizationNumber?: string | null;
  legalEntityType?: string | null;
  creditCheckStatus: CreditCheckStatus;
}

export interface JourContactModel {
  /** @format guid */
  id?: string | null;
  name: string;
  phone?: string | null;
  phone2?: string | null;
  email?: string | null;
  roleId: string;
}

export interface FinanceModel {
  isFixedPrice?: boolean | null;
  /** @format decimal */
  fixedPrice?: number | null;
  agreement?: string | null;
  pricelist?: PricelistModel | null;
  invoiceReferenceNumber?: string | null;
  invoiceText?: string | null;
  invoiceReferenceName?: string | null;
}

export interface PricelistModel {
  id: string;
  pricelistNumber: string;
  name: string;
}

export interface JourOrderModel {
  workDescription: string;
  foremanSignature?: string | null;
  workTypeId: string;
  workCauseId: string;
  departmentCode: string;
  administratorSignature: string;
  mainTechnicianSignature?: string | null;
}

export interface CreateWorkOrderModel {
  project?: WorkOrderProjectModel | null;
  object: ObjectModel;
  customer: CustomerModel;
  contacts: ContactModel[];
  finance: FinanceModel;
  order: OrderModel;
  planning: PlanningModel;
  insuranceClaim: InsuranceClaimModel;
  meps: MepsModel;
  zendesk?: ZendeskModel | null;
  sendConfirmationEmail: boolean;
  /** @format guid */
  draftId?: string | null;
  companyId?: string | null;
  subject?: string | null;
  officeId?: string | null;
  attachments?: WorkOrderAttachmentModel[] | null;
}

export interface WorkOrderAttachmentModel {
  fileName: string;
  contentUrl: string;
  contentType: string;
  /** @format int64 */
  realSize: number;
  /** @format int32 */
  width?: number | null;
  /** @format int32 */
  height?: number | null;
}

export interface WorkOrderProjectModel {
  /** @format guid */
  id: string;
  projectNumber: string;
}

export interface OrderModel {
  workDescription?: string | null;
  foreman?: UserModel | null;
  workType?: WorkTypeModel | null;
  workCause?: WorkCauseModel | null;
  department: DepartmentModel;
  administrator?: UserModel | null;
  mainTechnician?: UserModel | null;
  labels?: string[] | null;
  /** @format int32 */
  commentCount: number;
  shortDescription?: string | null;
}

export interface WorkTypeModel {
  id: string;
  name: string;
}

export interface WorkCauseModel {
  id: string;
  name: string;
}

export interface DepartmentModel {
  departmentCode: string;
  name: string;
}

export interface PlanningModel {
  /** @format date-time */
  plannedStartDate?: string | null;
  /** @format date-time */
  plannedEndDate?: string | null;
  /** @format decimal */
  expectedHoursReported?: number | null;
  /** @format int32 */
  appointmentCount: number;
}

export interface InsuranceClaimModel {
  hasInsuranceClaim: boolean;
  policyHolderName?: string | null;
  /** @format decimal */
  deductible?: number | null;
  insuranceCompany?: InsuranceCompanyModel | null;
}

export interface InsuranceCompanyModel {
  insuranceCompanyNumber?: string | null;
  name?: string | null;
}

export interface MepsModel {
  reference?: string | null;
}

export interface ZendeskModel {
  reference?: string | null;
  description?: string | null;
}

export interface AddLabelModel {
  name: string;
}

export interface ExpenseArticleRelationModel {
  articleNumber: string;
  name: string;
  recommendations: ExpenseReportArticleRecommendationModel[];
}

export interface ExpenseReportArticleRecommendationModel {
  articleNumber: string;
  name: string;
  unit: string;
  sourceOfRecommendation: string;
  /** @format decimal */
  quantity?: number | null;
}

export interface CreateExpenseReportOptionsModel {
  expenseItems: ExpenseItemModel[];
}

export interface ExpenseItemModel {
  id: string;
  name: string;
  unit: string;
}

export interface ExpenseReportArticleModel {
  articleNumber: string;
  name: string;
  unit: string;
}

export interface ExpenseOverviewWorkOrderModel {
  /** @format guid */
  workOrderId: string;
  workOrderNumber: string;
  address?: string | null;
  city?: string | null;
  department: DepartmentModel;
  hasAppointment: boolean;
  timeReporters: ExpenseOverviewTimeReporterModel[];
  expenseReports: ExpenseOverviewExpenseReportModel[];
}

export interface ExpenseOverviewTimeReporterModel {
  user: UserModel;
  timeReports: ExpenseOverviewTimeReportModel[];
}

export interface ExpenseOverviewTimeReportModel {
  timeType: TimeTypeModel;
  /** @format decimal */
  hours: number;
  comment: string;
}

export interface TimeTypeModel {
  id: string;
  name: string;
}

export interface ExpenseOverviewExpenseReportModel {
  createdBy: UserModel;
  article: ExpenseReportArticleModel;
  /** @format decimal */
  quantity: number;
  comment?: string | null;
}

export interface FileUpdateModel {
  /** @format int32 */
  visibilityLevel: number;
}

export interface FileTitleUpdateModel {
  title: string;
}

export interface FileModel2 {
  /** @format guid */
  id: string;
  type: FileType2;
  title: string;
  mimeType?: string | null;
  url: string;
  thumbnailUrl?: string | null;
  createdDate: string;
  size?: string | null;
  attachedToInvoice: boolean;
  /** @format int32 */
  mediaTypeId?: number | null;
  /** @format byte */
  isHidden: number;
  source: string;
}

export interface DownloadFileModel {
  /** @format guid */
  id: string;
  type: FileType2;
}

export interface HistoryModel {
  /** @format guid */
  id: string;
  name: string;
  user?: HistoryUserModel | null;
  /** @format date-time */
  createdDate: string;
  sourceSystem: SourceSystem;
  data: Record<string, string | null>;
}

export interface HistoryUserModel {
  signature: string;
  firstName: string;
  lastName: string;
  email?: string | null;
}

export interface WorkOrderOptionsModel {
  pricelists: PricelistOptionsModel[];
  departments: DepartmentModel[];
  foremen: UserModel[];
  mainTechnicians: UserModel[];
  administrators: UserModel[];
  workTypes: WorkTypeModel[];
  workCauses: WorkCauseOptionsModel[];
  defaultForeman?: UserModel | null;
  canCreateWorkOrder: boolean;
  offices: WorkOrderOfficeModel[];
}

export interface PricelistOptionsModel {
  id: string;
  pricelistNumber: string;
  name: string;
  isDefault: boolean;
}

export interface WorkCauseOptionsModel {
  id: string;
  name: string;
  groupId: string;
  groupName: string;
}

export interface ProjectListModel {
  /** @format guid */
  id: string;
  projectNumber: string;
  address?: string | null;
  department: DepartmentModel;
  workType?: WorkTypeModel | null;
  administrator?: UserModel | null;
  foreman?: UserModel | null;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  erpStatus: ProjectListModelErpStatus;
}

export interface ProjectListResultModel {
  entries: ProjectListModel[];
  /** @format int32 */
  total: number;
}

export interface SubtaskModel {
  /** @format guid */
  id: string;
  /** @format guid */
  workOrderId: string;
  /** @format guid */
  projectId: string;
  title: string;
  description?: string | null;
  status: SubtaskStatus;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  color?: string | null;
  /** @format int32 */
  expectedHoursReported?: number | null;
}

export interface CreateSubtaskModel {
  /** @format guid */
  workOrderId: string;
  title: string;
  description?: string | null;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  color?: string | null;
  /** @format int32 */
  expectedHoursReported?: number | null;
}

export interface UpdateSubtaskModel {
  title: string;
  description?: string | null;
  status: SubtaskStatus;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  color?: string | null;
  /** @format int32 */
  expectedHoursReported?: number | null;
}

export interface CreateTimeReportOptionsModel {
  timeTypes: TimeTypeModel[];
  defaultTimeTypeId?: string | null;
  allowedDates: string[];
}

export interface TimeReportStaffOverviewModel {
  user: UserModel;
  departments: DepartmentModel[];
  days: TimeReportStaffOverviewDayModel[];
}

export interface TimeReportStaffOverviewDayModel {
  /** @format date-time */
  date: string;
  /** @format decimal */
  hours: number;
  /** @format decimal */
  expectedHours: number;
}

export interface TimeReportUserOverviewModel {
  user: UserModel;
  days: TimeReportUserOverviewDayModel[];
}

export interface TimeReportUserOverviewDayModel {
  /** @format date-time */
  date: string;
  /** @format decimal */
  hours: number;
  /** @format decimal */
  expectedHours: number;
  workOrders: TimeReportUserOverviewWorkOrderModel[];
  absence: TimeReportUserOverviewAbsenceModel[];
}

export interface TimeReportUserOverviewWorkOrderModel {
  /** @format guid */
  id: string;
  workOrderNumber: string;
  objectAddress: AddressModel;
  timeReports: TimeReportUserOverviewTimeReportModel[];
}

export interface TimeReportUserOverviewTimeReportModel {
  /** @format decimal */
  hours: number;
  timeType: TimeTypeModel;
  comment: string;
}

export interface TimeReportUserOverviewAbsenceModel {
  /** @format decimal */
  hours: number;
  id: string;
  description: string;
}

export interface ToolArticleModel {
  articleNumber: string;
  name: string;
}

export interface GetUserSettingResponseModel {
  favoriteExpenseItemIds: string[];
}

export interface UpsertUserSettingModel {
  favoriteExpenseItemIds: string[];
}

export interface WorkDescriptionModel {
  workDescription?: string | null;
}

export interface WorkOrderAppointmentModel {
  /** @format guid */
  id: string;
  /** @format date-time */
  date: string;
  /** @format duration */
  startTime?: string | null;
  /** @format duration */
  endTime?: string | null;
  note?: string | null;
  assignedUsers: UserModel[];
  cars: CarModel[];
}

export interface CarModel {
  registrationNumber: string;
}

export interface WorkOrderConfirmationModel {
  sendEmail: boolean;
}

export interface WorkOrderModel {
  /** @format guid */
  id: string;
  companyId: string;
  createdBy?: UserModel | null;
  workOrderNumber: string;
  /** @format date-time */
  createdDate: string;
  project: WorkOrderProjectModel;
  object: ObjectModel;
  customer: CustomerModel;
  insuranceClaim: InsuranceClaimModel;
  contacts: ContactModel[];
  finance: FinanceModel;
  order: OrderModel;
  planning: PlanningModel;
  risk: RiskModel;
  meps: MepsModel;
  zendesk?: ZendeskModel | null;
  state: StateModel;
  selfInspection: SelfInspectionModel;
  operations: WorkOrderOperations;
  isOpen: boolean;
  /** @format guid */
  draftId?: string | null;
  subject?: string | null;
  office?: WorkOrderOfficeModel | null;
}

export interface WorkOrderOfficeModel {
  id: string;
  name: string;
  companyName: string;
}

export interface RiskModel {
  riskAssessment: RiskAssessment;
}

export interface StateModel {
  currentState: WorkOrderState;
}

export interface SelfInspectionModel {
  pre: SelfInspectionStageStateModel;
  post: SelfInspectionStageStateModel;
}

export interface SelfInspectionStageStateModel {
  state: SelfInspectionState;
}

export interface WorkOrderOperations {
  reporting: WorkOrderOperation;
  cancellation: WorkOrderOperation;
}

export interface WorkOrderOperation {
  isAllowed: boolean;
  reason?: string | null;
  description?: string | null;
}

export interface ExpenseReportModel {
  /** @format guid */
  id: string;
  /** @format date-time */
  date: string;
  createdBy: UserModel;
  /** @format decimal */
  quantity: number;
  article: ExpenseReportArticleModel;
  comment?: string | null;
  isDeletable: boolean;
}

export interface CreateExpenseReportModel {
  /** @format date-time */
  date: string;
  /** @format decimal */
  quantity: number;
  article: ExpenseReportArticleModel;
  comment?: string | null;
}

export interface InvoiceSubcontractor {
  invoiceNumber: string;
  /** @format date-time */
  createdDate: string;
  /** @format decimal */
  costAmount: number;
  /** @format date-time */
  invoiceDate: string;
  supplier: Supplier;
}

export interface Supplier {
  id: string;
  name: string;
}

export interface WorkOrderListResultModel {
  entries: WorkOrderListModel[];
  facets: Facet[];
  /** @format int32 */
  total: number;
}

export interface WorkOrderListModel {
  /** @format guid */
  id: string;
  workOrderNumber: string;
  address?: string | null;
  city?: string | null;
  workType?: string | null;
  foreman?: UserModel | null;
  /** @format date-time */
  createdDate?: string | null;
  hasRiskAssessment: boolean;
  labels: string[];
  /** @format int32 */
  commentCount: number;
  isOpen: boolean;
  currentState: WorkOrderState;
  objectTitle?: string | null;
  /** @format decimal */
  timeReportHours: number;
  /** @format int32 */
  expenseReportCount: number;
  shortDescription?: string | null;
  /** @format int32 */
  appointmentCount: number;
  /** @format date-time */
  plannedStartDate?: string | null;
  /** @format date-time */
  plannedEndDate?: string | null;
  /** @format decimal */
  expectedHoursReported?: number | null;
  /** @format int32 */
  toolRentedCount: number;
  /** @format int32 */
  toolReturnedCount: number;
  needsSelfInspection: boolean;
}

export interface Facet {
  name: string;
  values: FacetValue[];
}

export interface FacetValue {
  value: string;
  text: string;
}

export interface WorkOrderLookupModel {
  /** @format guid */
  id: string;
}

export interface TimeReportModel {
  /** @format guid */
  id: string;
  /** @format date-time */
  date: string;
  user: UserModel;
  createdBy: UserModel;
  /** @format decimal */
  hours: number;
  timeType: TimeTypeModel;
  comment: string;
  isDeletable: boolean;
}

export interface CreateTimeReportModel {
  /** @format date-time */
  date: string;
  /** @format decimal */
  hours: number;
  timeType: TimeTypeModel;
  comment: string;
}

export interface ToolModel {
  /** @format guid */
  id: string;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate?: string | null;
  location?: string | null;
  createdBy: UserModel;
  article: ToolArticleModel;
  isDeletable: boolean;
}

export interface RentToolModel {
  article: ToolArticleModel;
  /** @format date-time */
  startDate: string;
  location?: string | null;
}

export interface ReturnToolModel {
  /** @format date-time */
  endDate: string;
}

export interface WasteModel {
  article: WasteArticleModel;
  /** @format decimal */
  quantity: number;
}

export interface WasteArticleModel {
  articleNumber: string;
  name: string;
  unit: string;
}

export interface WorkOrderSummaryModel {
  /** @format guid */
  id: string;
  company: CompanyModel;
  workOrderNumber: string;
  address?: string | null;
  city?: string | null;
  workType?: string | null;
  foreman?: UserModel | null;
  /** @format date-time */
  createdDate?: string | null;
  currentState: WorkOrderState;
  objectTitle?: string | null;
  shortDescription?: string | null;
}

export interface CompanyModel {
  id: string;
  name: string;
}

export interface ZendeskTicketModel {
  /** @format int32 */
  id: number;
  description: string;
  subject: string;
  /** @format date-time */
  createdDate: string;
  availableTransitions: StatusTransition[];
  status: TicketStatusModel;
  customerInformation: CustomerInformationModel;
  attachments: AttachmentModel[];
}

export interface TicketStatusModel {
  /** @format int64 */
  id: number;
  label: string;
  statusCategory: string;
  isSolved: boolean;
}

export interface CustomerInformationModel {
  name?: string | null;
  phone?: string | null;
  email?: string | null;
  address?: string | null;
  address2?: string | null;
  postalCode?: string | null;
  city?: string | null;
  articleNumberIfs?: string | null;
  price?: string | null;
  description?: string | null;
  invoiceName?: string | null;
  invoiceEmail?: string | null;
  invoicePhone?: string | null;
  invoiceAddress?: string | null;
  invoiceAddress2?: string | null;
  invoicePostalCode?: string | null;
  invoiceCity?: string | null;
  invoiceOrgPersNumber?: string | null;
  invoiceCompany?: string | null;
  executionName?: string | null;
  executionEmail?: string | null;
  executionPhone?: string | null;
  executionAddress?: string | null;
  executionPostalCode?: string | null;
  executionCity?: string | null;
  executionCompany?: string | null;
  squareMeter?: string | null;
  property?: string | null;
  insuranceCompany?: string | null;
  insuranceClaimNumber?: string | null;
  workCause?: string | null;
  workType?: string | null;
}

export interface AttachmentModel {
  /** @format int64 */
  id: number;
  fileName: string;
  contentUrl: string;
  mappedContentUrl: string;
  contentType: string;
  size: string;
  /** @format int64 */
  realSize: number;
  /** @format int32 */
  width?: number | null;
  /** @format int32 */
  height?: number | null;
  thumbnails: ThumbnailModel[];
}

export interface ThumbnailModel {
  fileName: string;
  contentUrl: string;
  mappedContentUrl: string;
  contentType: string;
  /** @format int64 */
  size: number;
  /** @format int32 */
  width?: number | null;
  /** @format int32 */
  height?: number | null;
}
